export default {
  pageText: "{0} en",
  noDataText: "No data available",
  appBar: {
    siteTitle: "The development of first-person",
    siteTitleCorp: "Strickland Software Engineering Corp.",
    siteTitleCorpSmall: "Strickland Software",
    projects: "projects",
  },
  banner: {
    iosDescription: "Developing apps for mobile devices and Apple TV",
    androidDescription:
      "Development for Android for all types of mobile devices and TV",
    serverDescription:
      "Development of server APIs for mobile applications and beyond",
  },
  detail: {
    privacyPolicy: "Privacy policy",
    terms: "Terms of use",
  },
  appList: {
    moreDetailed: "More detailed...",
  },
  messageForm: {
    messageTitle: "Message to the developer",
    message: "Message",
    messageSuccess: "The message is sent",
    isRequired: "This field must be filled in",
    mustBeLess: "The field must contain no more than {0} characters",
    incorrectEmail: "Enter the correct email address",
    sendButton: "Send",
    appField: "Application",
    nameField: "Name",
    emailField: "Email",
  },
  not_found_component: {
    go_home: "To the main page",
    description: "Ooops... Error 404   We are sorry, but the page you are looking for does not exist."
  }
};
